import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { RichText } from "..";
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: (props) => (props.noMargin ? 0 : theme.spacing(6)),
        marginBottom: (props) => (props.noMargin ? 0 : theme.spacing(6)),
        width: "100%",
        display: "flex",
        flexDirection: "column",
        borderTop: "2px solid rgba(0, 0, 0, 0.12)",
        borderBottom: "2px solid rgba(0, 0, 0, 0.12)",
        [theme.breakpoints.up("sm")]: {
            flexDirection: "row"
        }
    },
    column: {
        width: "100%",
        padding: "24px 0 24px",
        [theme.breakpoints.up("sm")]: {
            widht: "50%",
            "&.left": {
                paddingRight: 32
            },
            "&.right": {
                paddingLeft: 32,
                paddingRight: 32,
                display: "flex",
                justifyContent: "flex-end"
            }
        }
    }
}));
export const DualInfo = (props) => {
    const classes = useStyles(props);
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: `${classes.column} left` },
            React.createElement(RichText, { text: props.Column1, noPadding: true })),
        React.createElement("div", { className: `${classes.column} right` },
            React.createElement(RichText, { text: props.Column2, noPadding: true }))));
};
export default DualInfo;
//# sourceMappingURL=DualInfo.js.map